import Enumerator from '../global/Enumerator';

export const verificationsEmploymentOptions = [
  'none',
  'google',
  'abn_check',
  'employer_call',
  'transaction_statements'
];

export class VerificationsEmploymentOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'google';
        break;
      case '2':
        correctOption = 'abn_check';
        break;
      case '3':
        correctOption = 'employer_call';
        break;
      case '4':
        correctOption = 'transaction_statements';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

VerificationsEmploymentOption.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  google: {
    get title() {
      return 'Google';
    }
  },
  abn_check: {
    get title() {
      return 'ABN check';
    }
  },
  employer_call: {
    get title() {
      return 'Employer call';
    }
  },
  transaction_statements: {
    get title() {
      return 'Transaction statements';
    }
  }
});

export default {
  verificationsEmploymentOptions,
  VerificationsEmploymentOption
};
